// extracted by mini-css-extract-plugin
export default {"alertIconContent":"ExternalPartScreen_alertIconContent__akMX+","form":"ExternalPartScreen_form__4JoPC","tabContainer":"ExternalPartScreen_tabContainer__I+ZIp"};